export default __webpack_public_path__ + "static/media/blue_hour_white.f29cf05a.svg";